import React from 'react'

const Head = () => {
  return (
    <>
        <section className='head'>
            <div className='container flexSB paddingTB'>
                <div className='logo'>
                    <img src='../images/logo.png' alt='logo' className='imglogo' />
                </div>
                <div className='ad'>
                    <img src='../images/headerb.png' alt='' />
                </div>
            </div>
        </section>
    </>
  )
}

export default Head
